var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 11.6682C11.9999 12.956 10.9948 14 9.75496 14C8.51513 14 7.51005 12.956 7.51005 11.6682C7.50943 11.5116 7.52448 11.3553 7.55495 11.2019L3.68623 8.79235C2.775 9.58499 1.42689 9.50253 0.611523 8.60427C-0.203841 7.706 -0.203841 6.30329 0.611523 5.40503C1.42689 4.50676 2.775 4.4243 3.68623 5.21695L7.55495 2.80743C7.52448 2.65402 7.50943 2.49773 7.51005 2.34108C7.50597 1.24958 8.23139 0.301189 9.25594 0.0585683C10.2805 -0.184052 11.33 0.344026 11.7818 1.32951C12.2336 2.31499 11.9668 3.49413 11.1396 4.16739C10.3125 4.84065 9.14642 4.82783 8.33319 4.13655L4.46447 6.53829C4.53421 6.84497 4.53421 7.16432 4.46447 7.471L8.33319 9.87274C9.00327 9.30311 9.92902 9.18456 10.7122 9.56809C11.4955 9.95161 11.9965 10.7688 11.9999 11.6682Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork);
export default __webpack_public_path__ + "static/media/icon-network.75075944.svg";
export { ForwardRef as ReactComponent };